import React, { useEffect, useState } from 'react';
import { useAuth } from '@apps-common/auth-react';

import { setupOnAuthSuccess, getClaims } from '@modules/auth/components/lib/auth/setup';

import FullPageLoader from '../FullPageLoader';
import { AuthorizationProps } from '../../types';

type Props = {
  children: React.ReactElement;
};

function SetupProvider({ children, ...props }: Props & AuthorizationProps) {
  const auth = useAuth();
  const [authInProgress, setAuthInProgress] = useState<boolean>(true);

  useEffect(() => {
    async function setup() {
      try {
        if (!auth.user) {
          throw Error('Not signed in!');
        }
        setAuthInProgress(true);
        await setupOnAuthSuccess(getClaims(auth.user), props);
      } catch (err) {
        console.error(err);
      } finally {
        setAuthInProgress(false);
      }
    }
    setup();
  }, []);

  if (authInProgress) {
    return <FullPageLoader />;
  }

  return children;
}

export default SetupProvider;
